module.exports = "https://img.xiyuyouxi.com/saas/img/de_icon3.0b9de4a9.png";